import React from "react";
import StudentReports from "../shared/reports/StudentReports";

function ControllerStudentReportsPage({ students }) {
  return <StudentReports students={students} />;
}

export default ControllerStudentReportsPage;
